import glamorous from 'glamorous';

export const UnbulletedList = glamorous.ul({
  listStyle: "none",
  marginLeft: "-2em",
});

export const FlexDiv = glamorous.div({ display: 'flex' });
export const FlexColDiv = glamorous(FlexDiv)({ flexDirection: 'column' });

export const Section = glamorous.section({
  display: 'flex',
  height: 'calc(100vh - 3em)',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: 'white'
});


// WEBPACK FOOTER //
// ./src/styles/container-elements.js